import { motion } from "framer-motion";
import { Flame, Plus } from "lucide-react";
import { PROMOS, PROMO_PRICE, formatBRL } from "../data/menu";
import { Chapter } from "./Chapter";

export const Promos = ({ onAdd }) => {
  const today = new Date().getDay();

  return (
    <div>
      <Chapter number="03" title="Açaí do dia · R$ 15" accent="#F59E0B">
        Toda semana, um combo diferente no copo de 300ml. A promoção vale
        apenas no dia da semana correspondente.
      </Chapter>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5">
        {PROMOS.map((p, i) => {
          const isToday = today === p.day;
          return (
            <motion.article
              key={p.day}
              data-testid={`promo-card-${p.day}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className={`relative flex flex-col rounded-[1.75rem] border p-6 transition-transform duration-300 hover:-translate-y-1.5 ${
                isToday
                  ? "border-amber-400 bg-[#3B0764] shadow-[0_0_45px_-10px_rgba(245,158,11,0.45)]"
                  : "border-purple-500/25 bg-[#2D0B5A]/60"
              }`}
            >
              {isToday && (
                <span
                  data-testid="promo-today-badge"
                  className="absolute -top-3 left-5 flex items-center gap-1.5 rounded-full bg-amber-400 px-3 py-1 text-[10px] font-extrabold uppercase tracking-widest text-[#1E053B]"
                >
                  <Flame className="h-3 w-3" /> Hoje
                </span>
              )}
              {p.image && (
                <img
                  src={p.image}
                  alt={`Açaí do dia de ${p.dayName}`}
                  className="mb-4 aspect-[4/3] w-full rounded-2xl border border-purple-500/20 object-cover"
                />
              )}
              <span
                className="font-grotesk text-xs font-bold uppercase tracking-[0.3em]"
                style={{ color: p.color }}
              >
                {p.dayName}
              </span>
              <h3 className="mt-3 font-syne text-lg font-extrabold leading-snug text-white">
                {p.combo}
              </h3>
              <p className="mt-2 text-xs text-purple-300/60">Copo 300ml de açaí</p>
              <div className="mt-5 flex items-center justify-between border-t border-purple-500/20 pt-4">
                <span className="font-syne text-2xl font-extrabold text-emerald-400">
                  {formatBRL(PROMO_PRICE)}
                </span>
                <button
                  type="button"
                  data-testid={`promo-order-${p.day}`}
                  onClick={() =>
                    onAdd({
                      title: `Açaí do Dia 300ml (${p.dayName})`,
                      details: [p.combo],
                      unitPrice: PROMO_PRICE,
                      qty: 1,
                    })
                  }
                  aria-label={`Adicionar promoção de ${p.dayName}`}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-purple-400/40 text-purple-100 transition-colors duration-300 hover:border-emerald-400 hover:bg-emerald-400 hover:text-[#1E053B]"
                >
                  <Plus className="h-4.5 w-4.5" strokeWidth={2.5} />
                </button>
              </div>
            </motion.article>
          );
        })}
      </div>

      <p className="mt-8 text-xs text-purple-300/50">
        *Ofertas válidas apenas para o dia da semana correspondente à promoção.
      </p>
    </div>
  );
};
